import { render } from "./SettingModal.vue?vue&type=template&id=3c96af1c&ts=true"
import script from "./SettingModal.vue?vue&type=script&lang=ts"
export * from "./SettingModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__